import ProtectedRoute from '@/components/ProtectedRoute';
import type { ReactElement } from 'react';
import { Route } from 'react-router-dom';
import type { UserRole } from '@/types/user';

/**
 * Utilitaires pour simplifier la création de routes
 */

/**
 * Crée une route protégée avec ProtectedRoute wrapper
 */
export function createProtectedRoute(path: string, element: ReactElement, requiredRole?: UserRole) {
  return (
    <Route
      key={path}
      path={path}
      element={<ProtectedRoute requiredRole={requiredRole}>{element}</ProtectedRoute>}
    />
  );
}

/**
 * Crée une route publique standard
 */
export function createPublicRoute(path: string, element: ReactElement) {
  return <Route key={path} path={path} element={element} />;
}

/**
 * Type pour définir une route de manière déclarative
 */
export interface RouteDefinition {
  path: string;
  element: ReactElement;
  protected?: boolean;
  requiredRole?: UserRole; // Rôle minimum requis (si protected: true)
}

/**
 * Crée des routes à partir d'un tableau de définitions
 */
export function createRoutesFromDefinitions(routes: RouteDefinition[]) {
  return routes.map(({ path, element, protected: isProtected = false, requiredRole }) =>
    isProtected
      ? createProtectedRoute(path, element, requiredRole)
      : createPublicRoute(path, element)
  );
}
